import { enroll } from '../../../state/enrollment/enrollmentActions';
import {
  EnrollmentType,
  EntityInfoFormData,
} from '../../../state/enrollment/enrollmentModel';
import Summary from '../Summary';

interface ReviewProps {
  entityInfo: EntityInfoFormData;
  enrollmentType: EnrollmentType;
  enroll: typeof enroll;
}

const Review = (props: ReviewProps) => {
  const { entityInfo, enrollmentType, enroll } = props;

  const onSubmit = () => enroll();

  return (
    <Summary
      onSubmit={onSubmit}
      isBulk={
        enrollmentType === EnrollmentType.MULTIPLE_ENTITY &&
        !!entityInfo.names?.length
      }
    />
  );
};

export default Review;
